/**
 * @Description 选址地图详情-右侧内容区域
 */

import { FC, useMemo } from 'react';
// import cs from 'classnames';
import styles from './index.module.less';
import AreaOverview from './components/AreaOverview';
import StoreList from './components/StoreList';
import ChanceList from './components/ChanceList';
// import ChancePoint from './components/ChancePoint';
import BussinessStore from './components/BussinessStore';
import Surround from './components/Surround';
import GatherList from './components/GatherList';
import EditableInfo from './components/EditableInfo';
// import BusinessStore from './components/BusinessStore'; // 经营门店

const FirstScreenRight: FC<any> = ({
  detail,
  overViewData,
  viewChanceDetail,
  chancepointAlias,
  setStoreChecked,
  setSurroundingChecked,
  curDetail,
  setCurDetail,
  storeOptions,
  setStoreOptions,
  setSurroundingOptions,
  mapIns,
  rangeMarkerRef,
  setIsOpenHeatMap,
  configSwitch,
  gatherList,
  isShare = false, // 是否是分享页
  shareParams = {},
  editModalData,
  modelConfigId,
  rangeSelectValue,
  isSemirModel = false,
}) => {

  // 生成中的商圈没有数据，不展示该模块
  const showOverview = useMemo(() => {
    let isShow = false;// 是否展示
    // 判断评分是否都不为空
    overViewData?.scores?.forEach((item) => {
      if (item && item.score) isShow = true;
    });
    return isShow;
  }, [overViewData]);

  return (
    <div className={styles.firstScreenRightCon}>
      {/* 商圈的概览信息 */}
      {
        showOverview
          ? <AreaOverview
            detail={detail}
            overViewData={overViewData}
            mapIns={mapIns}
            rangeMarkerRef={rangeMarkerRef}
            setIsOpenHeatMap={setIsOpenHeatMap}
            configSwitch={configSwitch}
            isShare={isShare}
            shareParams={shareParams}
            modelConfigId={modelConfigId}
            rangeSelectValue={rangeSelectValue}
            isSemirModel={isSemirModel}
          />
          : <></>
      }
      {/* 集客点列表 */}
      {
        isShare ? <></> : <GatherList
          gatherList={gatherList}
          clusterId={detail.id}
          detail={detail}
        />
      }
      {/* 本品牌门店 */}
      <StoreList
        detail={detail}
        viewDetail={viewChanceDetail}
        isShare={isShare}
        tenantId={shareParams?.tenantId}
        employeeId={shareParams.employeeId}
      />
      {/* 机会点新 */}
      <ChanceList
        detail={detail}
        viewChanceDetail={viewChanceDetail}
        chancepointAlias={chancepointAlias}
        isShare={isShare}
        tenantId={shareParams?.tenantId}
        employeeId={shareParams.employeeId}
      />
      {/* 机会点 */}
      {/* {
        isShare ? <></> : <ChancePoint
          detail={detail}
          viewChanceDetail={viewChanceDetail}
          chancepointAlias={chancepointAlias}
        />
      } */}
      {/* 新经营门店 */}
      {/* <BusinessStore/> */}
      {/* 经营门店 */}
      <BussinessStore
        detail={detail}
        setStoreChecked={setStoreChecked}
        storeOptions={storeOptions}
        setStoreOptions={setStoreOptions}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        isShare={isShare}
        shareParams={shareParams}
        rangeSelectValue={rangeSelectValue}
      />
      {/* 周边配套 */}
      <Surround
        detail={detail}
        setSurroundingChecked={setSurroundingChecked}
        setSurroundingOptions={setSurroundingOptions}
        curDetail={curDetail}
        setCurDetail={setCurDetail}
        isShare={isShare}
        shareParams={shareParams}
      />
      {/* 可编辑的开店区域详情备注&附件 */}
      <EditableInfo detail={editModalData?.data}/>
    </div>
  );
};

export default FirstScreenRight;
